import React from 'react';

type MaterialSearchPaginationProps = {
  searchPage: number;
  searchTotalPages: number;
  loading: boolean;
  onPageChange: (page: number) => void;
};

export function MaterialSearchPagination({
  searchPage,
  searchTotalPages,
  loading,
  onPageChange,
}: MaterialSearchPaginationProps) {
  return (
    <div className="px-4 py-3 border-t border-app-border flex items-center justify-between gap-2">
      <span className="text-xs text-app-text-subtle">
        Seite {searchPage.toLocaleString('de-DE')} von {searchTotalPages.toLocaleString('de-DE')}
      </span>
      <div className="flex items-center gap-1">
        <button
          type="button"
          disabled={searchPage <= 1 || loading}
          onClick={() => onPageChange(Math.max(1, searchPage - 1))}
          className="inline-flex h-9 items-center rounded-md border border-app-border bg-app-surface px-3.5 text-sm font-medium text-app-text-muted hover:bg-app-hover disabled:cursor-not-allowed disabled:opacity-40"
        >
          ← Zurück
        </button>
        <button
          type="button"
          disabled={searchPage >= searchTotalPages || loading}
          onClick={() => onPageChange(Math.min(searchTotalPages, searchPage + 1))}
          className="inline-flex h-9 items-center rounded-md border border-app-border bg-app-surface px-3.5 text-sm font-medium text-app-text-muted hover:bg-app-hover disabled:cursor-not-allowed disabled:opacity-40"
        >
          Weiter →
        </button>
      </div>
    </div>
  );
}
